import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b205948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-place" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "pagination-container" }
const _hoisted_4 = { class: "dialog-footer" }

import { ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddMembersDialog from './AddMembersDialog.vue';
import { groupFarmerList, groupFarmerDelete } from '../api.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectiveMembersDialog',
  props: {
    visible: { type: Boolean },
    collectiveId: null
  },
  emits: ['update:visible'],
  setup(__props: any, { emit }) {

const props = __props as {
    visible: boolean;
    collectiveId: string;
};





const dialogVisible = ref(false);
const addMemberDialogVisible = ref(false);
const members = ref([]);

const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);

const handleSizeChange = (val: number) => {
    pageSize.value = val;
    loadMembers();
};

const handleCurrentChange = (val: number) => {
    currentPage.value = val;
    loadMembers();
};

watch(() => props.visible, (newVisible) => {
    dialogVisible.value = newVisible;
    if (newVisible) {
        loadMembers();
    }
});

watch(dialogVisible, (newVisible) => {
    emit('update:visible', newVisible);
});

const loadMembers = () => {
    const params = {
        condition: {
            id: props.collectiveId,
        },
        pageIndex: currentPage.value,
        pageSize: pageSize.value
    };

    groupFarmerList(params).then((res: any) => {
        if (res) {
            members.value = res.items;
            total.value = Number(res.totalSize);
        } else {
            ElMessage.error(res.message || "获取团体成员失败");
        }
    }).catch((error: any) => {
        console.error("Error fetching group members:", error);
        ElMessage.error("获取团体成员失败，请重试");
    });
};

const handleClose = () => {
    dialogVisible.value = false;
};

const removeMember = (memberId: string, farmerId: string, groupId: string) => {
    ElMessageBox.confirm(
        '确定要删除该成员吗？',
        '删除确认',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        const params = {
            id: memberId,
            farmerId: farmerId,
            groupId: groupId
        };

        groupFarmerDelete(params)
            .then(() => {
                ElMessage.success('成员删除成功');
                loadMembers();
            })
            .catch(error => {
                console.error('删除成员失败:', error);
            });
    })
};

const openAddMemberDialog = () => {
    addMemberDialogVisible.value = true;
};

const closeAddMemberDialog = () => {
    addMemberDialogVisible.value = false;
};

const handleAddMembers = (newMembers) => {
    ElMessage.success('成员添加成功');
    loadMembers();
    closeAddMemberDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: "团体成员",
      width: "80%",
      "before-close": handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: handleClose }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: openAddMemberDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加成员")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_table, {
            data: members.value,
            border: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "序号",
                width: "60",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "farmerName",
                label: "养殖户姓名",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "idCard",
                label: "证件号码",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (removeMember(scope.row.id, scope.row.farmerId, props.collectiveId))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            "current-page": currentPage.value,
            "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            "page-size": pageSize.value,
            "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
            "page-sizes": [10, 20, 50, 100],
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange,
            layout: "total, sizes, prev, pager, next, jumper"
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AddMembersDialog, {
      visible: addMemberDialogVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((addMemberDialogVisible).value = $event)),
      collectiveId: __props.collectiveId,
      onConfirm: handleAddMembers,
      onCancel: closeAddMemberDialog
    }, null, 8, ["visible", "collectiveId"])
  ], 64))
}
}

})